import React from 'react';

import { Divider, makeStyles } from '@material-ui/core';

import { DateInput, TextInput, ImageUpload, RichTextEditor, TimeInput } from '../EditorFormElements';
import { Collapsible, FormFieldWrapper } from '../Global';

import makePath from '../../utils/makePath';

const useStyles = makeStyles(theme => ({
  date: {
    flex: '1 1 150px',
    maxWidth: 220,
  }
}))

export const Event = ({ given={},index, ...props }) => {
  const classes = useStyles();
  const path = makePath(props.path,index)
  
  return (
    <Collapsible headerTag="h4" title={`Event ${index + 1}`} sortableChild>

      <FormFieldWrapper>
        
        <DateInput 
          name="date"
          label="Date"
          path={path}
          given={given.date}
          classes={classes.date}
        />
      
        {props.format === 'datetime'  ?

          <TimeInput
            name="time"
            label="Time"
            help="Use format 1:00 AM."
            path={path}
            given={given.time}
          />

        : '' }
      
        <TextInput
          name="flagTitle"
          label="Event Label"
          path={path}
          given={given.flagTitle}
          max={55}
          validationCriteria={{optional: true}}
          help="This field is optional."
        />
      
      </FormFieldWrapper>

      <Divider />

      <FormFieldWrapper>
          
        <TextInput
          name="headline"
          label="Event Heading"
          defaultText="Event Heading"
          path={path}
          given={given.headline}
        />

        <RichTextEditor
          name="body"
          // label="Body"
          path={path}
          defaultValue="Enter body text for the event."
          controls={['bold', 'italic', 'underline', 'link']} 
          given={given.body}
          max={250}
        />

        <ImageUpload
          name="image"
          label="Event Image"
          tooltip="Upload an image to display with this event. Image size should have a max width of 512px and a max height of 800px and not exceed 75KB."
          path={path}
          given={given.image}
        />

        {/**
          *  Special Case Alt Text: 
          *  Because these images tend to contain a lot of info, this 
          *  "alt" text is actually a separate HTML caption that allows screenreaders to more
          *  easily digest long text descriptions.
          */}
        <RichTextEditor
          name="screenReaderCaption"
          label="Image Alt Text"
          path={path}
          placeholder="Provide image alt text that describes image to support screen readers."
          controls={['bold', 'italic', 'underline', 'link']} 
          given={given.screenReaderCaption}
        />

      </FormFieldWrapper>

      {props.deleteBtn}

    </Collapsible>
  )
}
